import { useCallback, useState, useEffect } from 'react';

import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { createContainer, useContainer } from 'unstated-next';

import { GET_USER_DATA } from '../../../../../config/apiPaths';
import { getUrlParams, getUrls, processApiPath } from '../../../../../utils/url';
import AdminAuthContainer from '../../../AdminAuthContainer';

interface FeedbackContainerState {
    feedbackData?: Record<string, any>; // result of the GET_CLASS_DATA_PATH api call
}

type LoadingStatus = 'INITIAL' | 'LOADING' | 'SUCCESS' | 'ERROR';

const useFeedbackContainer = (state: FeedbackContainerState = {}) => {
    console.log('FeedbackContainer');
    const { api } = getUrls();

    const [feedbackData, setFeedbackData] = useState<any>();

    const { t: tCommon } = useTranslation('common');

    const { authMode } = useContainer(AdminAuthContainer);

    const search = new URLSearchParams(window.location.search);
    const feedbackUuid = search.get('feedback_uuid') || window.localStorage.getItem('feedback_uuid');

    const [getFeedbackStatus, setGetFeedbackStatus] = useState<LoadingStatus>('INITIAL');
    const [errorMessage, setErrorMessage] = useState<string>('');

    const { feedbackId: feedbackIdV1 } = useParams<{ feedbackId?: string }>();
    const { feedback_id: feedbackIdV2 } = getUrlParams();
    const feedbackId = feedbackIdV1 || feedbackIdV2 || '';

    const returnErrorMessage = useCallback(
        (error: any): string => {
            console.error(error);
            return tCommon('errorMessage');
        },
        [tCommon]
    );

    const getFeedbackDataCall = useCallback(async () => {
        const { data } = await axios.get(
            processApiPath(GET_USER_DATA, undefined, {
                feedback_uuid: feedbackUuid!,
                feedback_id: feedbackId,
                auth_mode: authMode
            })
        );

        if (data?.success === false) {
            throw Error(data?.error);
        }
        return data;
    }, [feedbackUuid, feedbackId, authMode]);

    const getFeedback = useCallback(async () => {
        setGetFeedbackStatus('LOADING');

        try {
            const data = state.feedbackData ?? (await getFeedbackDataCall());

            setFeedbackData(data);
            setGetFeedbackStatus('SUCCESS');
        } catch (err) {
            const errorMsg = returnErrorMessage(err);
            setErrorMessage(errorMsg);
            setGetFeedbackStatus('ERROR');
        }
    }, [state.feedbackData, getFeedbackDataCall, returnErrorMessage]);

    useEffect(() => {
        if (feedbackId && feedbackUuid) {
            getFeedback();
        }
    }, [feedbackId, getFeedback, feedbackUuid]);

    return {
        feedbackId,
        api,
        feedbackData,
        getFeedbackStatus,
        errorMessage
    };
};

const FeedbackContainer = createContainer(useFeedbackContainer);

export default FeedbackContainer;
